/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';
import { ISuggestionsRealtorFormSchema } from '../../entities/entities/SuggestionsRealtorFormSchema';

export type TSuggestRealtorFormModel = IModel<ISuggestRealtorFormRequest, TSuggestRealtorFormResponse>;

export interface ISuggestRealtorFormRequest {
  /** Требуемые типы предложений **/
  suggestionTypes?: ESuggestionTypes[] | null;
  /** Id региона **/
  regionId?: number | null;
  /** Запрос пользователя **/
  query?: string | null;
}

export type TSuggestRealtorFormResponse = ISuggestRealtorFormResponse200 | ISuggestRealtorFormResponse400;

export interface ISuggestRealtorFormResponse200 extends IModelResponse<ISuggestRealtorFormResponse> {
  statusCode: 200;
}

export interface ISuggestRealtorFormResponse400 extends IModelResponse<ISuggestRealtorFormResponseError> {
  statusCode: 400;
}

export interface ISuggestRealtorFormResponse {
  /** Порядок подсказок в саджесте **/
  sortOrder: string[];
  /** Подсказки **/
  suggestions: ISuggestionsRealtorFormSchema;
}

export interface ISuggestRealtorFormResponseError {
  errors: any[];
  message: string;
}

export type TResponses = ISuggestRealtorFormResponse | ISuggestRealtorFormResponseError;

export enum ESuggestionTypes {
  /** Саджест от Яндекса **/
  Address = 'address',
  /** Застройщик **/
  Builder = 'builder',
  /** БЦ **/
  BusinessCenter = 'businessCenter',
  /** Город **/
  City = 'city',
  /** Район **/
  District = 'district',
  /** ЖК **/
  Newbuilding = 'newbuilding',
  /** ЖД-станция **/
  Railway = 'railway',
  /** Шоссе **/
  Road = 'road',
  /** ТЦ **/
  ShoppingCenter = 'shoppingCenter',
  /** Метро **/
  Underground = 'underground',
  /** КП **/
  Village = 'village',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: ISuggestRealtorFormResponse): TResponse200;
  400(response: ISuggestRealtorFormResponseError): TResponse400;
}
